import { render, staticRenderFns } from "./ipPhone.vue?vue&type=template&id=37a3f219&scoped=true&"
import script from "./ipPhone.vue?vue&type=script&lang=js&"
export * from "./ipPhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a3f219",
  null
  
)

export default component.exports